/**
 * This file contains the configuration for the data sources.
 * It provides the remote URL for API calls for specific feeds.
 * "Dimensions" are the different types of data that can be displayed for a feed type.
 * Tabular data needs column information, and chart data needs a yfield - which maps to the main table data.
 */
export default {
  xbl: {
    // Overview widget type
    overview: {
      url: "xbl/overview",
    },
    // country specific handling
    country: {
      title: "Detections by country",
      titleTooltip: "The geolocation of the detected IP.",
      table: {
        url: "xbl/table/country",
        columns: [
          { title: "Rank", key: "rank", type: "rank" },
          { title: "", key: "country_code", type: "country_flag" },
          { title: "Country", key: "country_name" },
          { title: `No. of detections (current)`, key: "value", type: "num" },
          { title: `Last period (30 days)`, key: "previous", type: "num" },
          { title: "Monthly Change", key: "change", type: "change" },
        ],
      },
      timeline: {
        url: "xbl/timeline/country",
        yfield: "country_name",
      },
      chart: {
        yfield: "country_name",
        columns: [
          { title: "Rank", key: "rank", type: "rank" },
          { title: "Country", key: "name" },
          { title: "No. of detections", key: "value", type: "num" },
          { title: "% share", key: "percent", type: "percent" },
        ],
      },
      top: {
        title: "Detections by Country",
        url: "xbl/table/country?l=1&o=change&c=daily",
        field: "country_name",
      },
    },
    // isp specific handling
    isp: {
      title: "ISPs associated with detections",
      titleTooltip:
        "The number of botnets being hosted by individual Internet Service Providers (ISPs)",
      table: {
        url: "xbl/table/isp",
        columns: [
          { title: "Rank", key: "rank", type: "rank" },
          { title: "ISP", key: "isp_name" },
          { title: `No. of detections (current)`, key: "value", type: "num" },
          { title: `Last period (30 days)`, key: "previous", type: "num" },
          { title: "Monthly Change", key: "change", type: "change" },
        ],
      },
      timeline: {
        url: "xbl/timeline/isp",
        yfield: "isp_name",
      },
      chart: {
        yfield: "isp_name",
        columns: [
          { title: "Rank", key: "rank", type: "rank" },
          { title: "ISP", key: "name" },
          { title: "No. of detections", key: "value", type: "num" },
          { title: "% share", key: "percent", type: "percent" },
        ],
      },
      top: {
        title: "Detections by ISP",
        url: "xbl/table/isp?l=1&o=change&c=daily",
        field: "isp_name",
      },
    },
    // botname specific handling
    botname: {
      title: "Malware associated with detections",
      titleTooltip:
        "The number of botnet IPs associated with specific malware families.",
      table: {
        url: "xbl/table/botname",
        columns: [
          { title: "Rank", key: "rank", type: "rank" },
          { title: "Botname", key: "botname" },
          { title: `No. of detections (current)`, key: "value", type: "num" },
          { title: `Last period (30 days)`, key: "previous", type: "num" },
          { title: "Monthly Change", key: "change", type: "change" },
        ],
      },
      timeline: {
        url: "xbl/timeline/botname",
        yfield: "botname",
      },
      chart: {
        yfield: "botname",
        columns: [
          { title: "Rank", key: "rank", type: "rank" },
          { title: "Botname", key: "name" },
          { title: "No. of detections", key: "value", type: "num" },
          { title: "% share", key: "percent", type: "percent" },
        ],
      },
      top: {
        title: "Detections by Malware",
        url: "xbl/table/botname?l=1&o=change&c=daily",
        field: "botname",
      },
    },
  },

  // BCL config
  bcl: {
    // Overview widget type
    overview: {
      url: "bcl/overview",
    },
    // country specific handling
    country: {
      title: "Detections by country",
      titleTooltip: "The geolocation of the detected IP.",
      table: {
        url: "bcl/table/country",
        columns: [
          { title: "Rank", key: "rank", type: "rank" },
          { title: "", key: "country_code", type: "country_flag" },
          { title: "Country", key: "country_name" },
          { title: `No. of detections (current)`, key: "value", type: "num" },
          { title: `Last period (30 days)`, key: "previous", type: "num" },
          { title: "Monthly Change", key: "change", type: "change" },
        ],
      },
      timeline: {
        url: "bcl/timeline/country",
        yfield: "country_name",
      },
      chart: {
        yfield: "country_name",
        columns: [
          { title: "Rank", key: "rank", type: "rank" },
          { title: "Country", key: "name" },
          { title: "No. of detections", key: "value", type: "num" },
          { title: "% share", key: "percent", type: "percent" },
        ],
      },
      top: {
        title: "Detections by Country",
        url: "bcl/table/country?l=1&o=change&c=daily",
        field: "country_name",
      },
    },
    // isp specific handling
    isp: {
      title: "ISPs associated with detections",
      titleTooltip:
        "The number of botnets being hosted by individual Internet Service Providers (ISPs)",
      table: {
        url: "bcl/table/isp",
        columns: [
          { title: "Rank", key: "rank", type: "rank" },
          { title: "ISP", key: "isp_name" },
          { title: `No. of detections (current)`, key: "value", type: "num" },
          { title: `Last period (30 days)`, key: "previous", type: "num" },
          { title: "Monthly Change", key: "change", type: "change" },
        ],
      },
      timeline: {
        url: "bcl/timeline/isp",
        yfield: "isp_name",
      },
      chart: {
        yfield: "isp_name",
        columns: [
          { title: "Rank", key: "rank", type: "rank" },
          { title: "ISP", key: "name" },
          { title: "No. of detections", key: "value", type: "num" },
          { title: "% share", key: "percent", type: "percent" },
        ],
      },
      top: {
        title: "Detections by ISP",
        url: "bcl/table/isp?l=1&o=change&c=daily",
        field: "isp_name",
      },
    },
    // botname specific handling
    botname: {
      title: "Malware associated with detections",
      titleTooltip:
        "The number of botnet IPs associated with specific malware families.",
      table: {
        url: "bcl/table/botname",
        columns: [
          { title: "Rank", key: "rank", type: "rank" },
          { title: "Botname", key: "botname" },
          { title: `No. of detections (current)`, key: "value", type: "num" },
          { title: `Last period (30 days)`, key: "previous", type: "num" },
          { title: "Monthly Change", key: "change", type: "change" },
        ],
      },
      timeline: {
        url: "bcl/timeline/botname",
        yfield: "botname",
      },
      chart: {
        yfield: "botname",
        columns: [
          { title: "Rank", key: "rank", type: "rank" },
          { title: "Botname", key: "name" },
          { title: "No. of detections", key: "value", type: "num" },
          { title: "% share", key: "percent", type: "percent" },
        ],
      },
      top: {
        title: "Detections by Malware",
        url: "bcl/table/botname?l=1&o=change&c=daily",
        field: "botname",
      },
    },
  },
};
